import api from './api';

export default {
  getOperations({
    operationTypes, sortBy, descending, offset, count,
  }) {
    return api.get('/operationshistory/api/v1/operations', {
      params: {
        operationTypes,
        sortBy,
        descending,
        offset,
        count,
      },
    });
  },
  getParticipantOperations({
    participantId, tags = [], tagsQuery = '', object = null, offset = 0, count = 200,
  }) {
    const body = {
      tags,
      tagsQuery,
    };

    if (object && Object.keys(object).length > 0) {
      body.object = object;
    }

    return api.post(`/operationshistory/api/v1/operations/participants/${participantId}`, body, {
      params: { offset, count },
    });
  },
  searchEvents({
    subjectId, tags = [], tagsQuery = '', object = null, offset = 0, count = 20,
  }) {
    const body = {
      subjectId,
      tags,
      tagsQuery,
    };

    if (object && Object.keys(object).length > 0) {
      body.object = object;
    }

    return api.post('/operationshistory/api/v1/operations/search', body, {
      params: { offset, count },
    });
  },

};
